<mat-form-field
  class="w-100 remove-subscript emails-field"
  appearance="outline"
>
  <mat-chip-grid
    #chipGrid
    aria-label="Enter email addresses"
    name="grid"
    [formControl]="email"
  >
    @for (email of emailsList; track email; let index = $index) {
      <mat-chip-row
        class="rv-input-pill"
        tabindex="0"
        (removed)="onRemove(index)"
        [editable]="false"
      >
        {{ email }}
        <button
          matChipRemove
          [attr.aria-label]="'Remove ' + email + ' from email list'"
        >
          <mat-icon svgIcon="close" />
        </button>
      </mat-chip-row>
    }
    <input
      [name]="name"
      [placeholder]="placeholderText"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (keyup)="onInputChange($event.target.value)"
      (change)="onInputChange($event.target.value)"
      (blur)="_validate($event.target.value)"
      (matChipInputTokenEnd)="onTokenEnd($event)"
      [id]="id"
    />
  </mat-chip-grid>
</mat-form-field>
